import { LayoutComponent } from './layouts/layout/layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { authGuard } from 'src/service/authguard/auth.guard';

export const appRoutes: VexRoutes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/pages/auth/login/login.component').then(
        (m) => m.LoginComponent
      ),
      
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./pages/pages/auth/changepassword/changepassword.component').then(
        (m) => m.ChangePasswordComponent
      )
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import(
        './pages/pages/auth/forgot-password/forgot-password.component'
      ).then((m) => m.ForgotPasswordComponent)
  },
  {
    path: 'coming-soon',
    loadComponent: () =>
      import('./pages/pages/coming-soon/coming-soon.component').then(
        (m) => m.ComingSoonComponent
      )
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboards/analytics',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        path: 'dashboards/admin',
        loadComponent: () =>
          import('./pages/dashboards/admin-dashboard/admin-dashboard.component').then(
            (m) => m.AdminDashboardComponent
          ),
        data: {
          toolbarShadowEnabled: false
        }
      },
      {
        path: 'dashboards/probation-officer',
          loadComponent: () =>
            import('./pages/dashboards/dashboard-analytics/dashboard-analytics.component').then(
              (m) => m.DashboardAnalyticsComponent
            ),
          data: {
            toolbarShadowEnabled: false
          }
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/apps/help-center/help-center.routes')
      },
      {
        path: 'apps',
        children: [
          {
            path: 'labs-management',
            loadComponent: () =>
              import('./pages/apps/labs-management/lab-branch-table.component').then(
                (m) => m.LabBranchTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'compliance-management',
            loadComponent: () =>
              import('./pages/apps/compliance-management/compliance-management.component').then(
                (m) => m.ComplianceManagementComponent
              ),
            data: {
              toolbarShadowEnabled: false 
            }
          },
          {
            path: 'lab-staff-management',
            loadComponent: () =>
              import('./pages/apps/lab-staff-management/lab-staff-table.component').then(
                (m) => m.LabStaffTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'probation-staff-management',
            loadComponent: () =>
              import('./pages/apps/probation-staff-management/probation-staff-table.component').then(
                (m) => m.ProbationStaffTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'probationer-management',
            loadComponent: () =>
              import('./pages/apps/probationer-management/probationer-table.component').then(
                (m) => m.ProbationerTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'probationer/:id',
            loadComponent: () =>
              import('./pages/apps/probationer-details/probationer-details.component').then(
                (m) => m.ProbationerDetailsComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'lab-test-management',
            loadComponent: () =>
              import('./pages/apps/lab-test-management/lab-test-table.component').then(
                (m) => m.LabTestTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'test-type-management',
            loadComponent: () =>
              import('./pages/apps/test-type-management/test-type-table.component').then(
                (m) => m.TestTypesTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'admin-user-guide',
            loadComponent: () =>
              import('./pages/ui/page-layouts/help-pages/help-pages.component').then(
                (m) => m.HelpPagesComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
           {
            path: 'probation-officer-user-guide',
            loadComponent: () =>
              import('./pages/ui/page-layouts/help-pages/help-pages.component').then(
                (m) => m.HelpPagesComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'probation-director-user-guide',
            loadComponent: () =>
              import('./pages/ui/page-layouts/help-pages/help-pages.component').then(
                (m) => m.HelpPagesComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'lab-technician-user-guide',
            loadComponent: () =>
              import('./pages/ui/page-layouts/help-pages/help-pages.component').then(
                (m) => m.HelpPagesComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'lab-manager-user-guide',
            loadComponent: () =>
              import('./pages/ui/page-layouts/help-pages/help-pages.component').then(
                (m) => m.HelpPagesComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'next-day-tests',
            loadComponent: () =>
              import('./pages/apps/lab-test-management/lab-test-table.component').then(
                (m) => m.LabTestTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'today-tests',
            loadComponent: () =>
              import('./pages/apps/lab-test-management/lab-test-table.component').then(
                (m) => m.LabTestTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'organization-management',
            loadComponent: () =>
              import('./pages/apps/organization-management/organization-table.component').then(
                (m) => m.OrganizationTableComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          },
          {
            path: 'help-center',
            loadChildren: () =>
              import('./pages/apps/help-center/help-center.routes')
          },
          {
            path: 'account-settings',
            loadComponent: () =>
              import('./pages/apps/account-settings/account-settings.component').then(
                (m) => m.AccountSettingsComponent
              ),
            data: {
              toolbarShadowEnabled: false
            }
          }
        ]
      },
      {
        path: 'pages',
        children: [
          {
            path: 'pricing',
            loadComponent: () =>
              import('./pages/pages/pricing/pricing.component').then(
                (m) => m.PricingComponent
              )
          },
          {
            path: 'faq',
            loadComponent: () =>
              import('./pages/pages/faq/faq.component').then(
                (m) => m.FaqComponent
              )
          },
          {
            path: 'guides',
            loadComponent: () =>
              import('./pages/pages/guides/guides.component').then(
                (m) => m.GuidesComponent
              )
          },
          {
            path: 'invoice',
            loadComponent: () =>
              import('./pages/pages/invoice/invoice.component').then(
                (m) => m.InvoiceComponent
              )
          },
          {
            path: 'error-404',
            loadComponent: () =>
              import('./pages/pages/errors/error-404/error-404.component').then(
                (m) => m.Error404Component
              )
          },
          {
            path: 'error-500',
            loadComponent: () =>
              import('./pages/pages/errors/error-500/error-500.component').then(
                (m) => m.Error500Component
              )
          }
        ]
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/pages/errors/error-404/error-404.component').then(
            (m) => m.Error404Component
          )
      }
    ]
  }
];
